module.exports = __webpack_public_path__ + "static/img/score-sentimento.e7f45fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/score-sentimento.png
// module id = twWc
// module chunks = 1